<template>
    <cusPopup v-if="showBoo" :closeOnClickOverlay="false">
        <view class="cusModal">
            <view class="titles" v-if="title">
                {{ title }}
            </view>
            <slot>
                <view class="content" v-if="content">
                    {{ content }}
                </view>
            </slot>
            <view class="btn">
                <view class="cancle sub-btn" @click="cancle">取消</view>
                <view class="chat sub-btn" @click="confirm">确定</view>
            </view>
        </view>
    </cusPopup>
</template>

<script setup>
    import cusPopup from './cusPopup.vue';
    const showBoo = defineModel('showBoo');
    const $props = defineProps({
        zIndex: {
            type: [Number, String],
            default: 10076
        },
        width: {
            type: String,
            default: '480px'
        },
        content: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: '提示'
        },
        callBackFun: {
            type: Function
        },
        closeOnClickOverlay: {
            type: Boolean,
            default: true
        }
    });

    const $emits = defineEmits(['confirm', 'close']);

    const cancle = () => {
        $emits('close');
        // showBoo.value = false;
    };
    const confirm = () => {
        console.log('========', typeof $props.callBackFun == 'function');
        if (typeof $props.callBackFun == 'function') {
            return $props.callBackFun();
        } else {
            $emits('confirm');
            showBoo.value = false;
        }
    };
</script>

<style lang="scss" scoped>
    :deep(.uv-line) {
        display: none;
    }
    :deep(.uv-modal__content) {
        background-color: #fff !important;
    }
    .cusModal {
        background-color: #fff !important;
        padding: 25px;
        .titles {
            font-size: 40rpx;
            color: #4f5767;
            font-weight: 600;
            margin-bottom: 30px;
            display: block;
            text-align: center;
            font-size: 26px;
        }
        .content {
            font-size: 24px;
            margin: 30px 20px;
            text-align: center;
        }
        .btn {
            display: flex;
            justify-content: space-around;
            padding-bottom: 10px;
            width: 100%;
            view {
                flex: 1;
                font-size: 24px;
                white-space: nowrap;
                padding: 0px 65px;
                color: #fff;
                margin: 0 20px;
                border: 1px solid transparent;
            }
            .cancle {
                border-color: #828282;
                background: transparent;
                color: #828282;
            }
            .chat {
                // background: $btn-color;
            }
        }
    }
</style>
